import React, { ReactNode } from 'react';

import { logoGrid as logoGridStyle } from './styles.module.css';

export interface LogoGridProps<T> {
	items: Array<T>;
	renderItem(item: T, index: number): ReactNode;
}

export const LogoGrid = <T,>({ items, renderItem }: LogoGridProps<T>): JSX.Element => {
	return <div className={logoGridStyle}>{items.map((logo, idx) => renderItem(logo, idx))}</div>;
};
